<div class="ca-trend-badge inline-flex gap-x-2 px-2 py-1" [ngClass]="trend()">
    <mat-icon fontSet="ca" [fontIcon]="icon()"></mat-icon>
    <span class="ca-headline-5 my-auto whitespace-nowrap">{{ displayedValue() }} %</span>
</div>
